import React, { useEffect, useState } from 'react'
import List from '../../components/List'
import FloatingButton from '../../components/UI/FloatingButton'
import SwitchInput from '../../components/UI/SwitchInput'
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getBundleManagementList, saveBundleManagement } from '../../services/bundleManagement'
import {bundleManager, bundleManagerList} from './types'
import { CSVLink } from "react-csv"
import {PlusOutlined} from "@ant-design/icons";


function index(props: {accessLevel: string}) {
  const {canEdit} = useAuth()
  const loading = useLoading()
  const [bundleManagementList, setBundleManagementList] = useState<bundleManager[]>([])
  const [bundleManagementInitial, setBundleManagementInitial] = useState<bundleManager[]>([])
  const [changed, setChanged] = useState<boolean>(false)
  const log = {
    log_type: 'visited',
    log_object: 'bundle_management'
  }
  const headers = [
    { label: 'Title', key: 'title' },
    { label: 'Enable POS', key: 'enablePos' },
    { label: 'Enable Game', key: 'enableGame' },
    { label: 'Unloadable', key: 'unloadable'}
  ];

  useEffect(() => {
    sendSystemLog(log);
    onRefresh();
  }, [])

  useEffect(() => {
    /*
    console.log("Current Bundles Changed")
    console.log("Current Bundles")
    console.log(JSON.stringify(bundleManagementList))
    console.log("Initial Bundles")
    console.log(JSON.stringify(bundleManagementInitial))
    let same = JSON.stringify(bundleManagementInitial) === JSON.stringify(bundleManagementList)
    console.log("Bundles different = " + !same)

    */
    checkChanged()
  }, [bundleManagementList])

  useEffect(() => {
    //console.log("Initial Bundles Changed")
    //console.log("Current Bundles")
    //console.log(JSON.stringify(bundleManagementList))
    //console.log("Initial Bundles")
    //console.log(JSON.stringify(bundleManagementInitial))
    //let same = JSON.stringify(bundleManagementInitial) === JSON.stringify(bundleManagementList)
    //console.log("Bundles different = " + !same)
    checkChanged()
  }, [bundleManagementInitial])

  const checkChanged = () => {
    let tempChanged = false
    const payload: bundleManagerList = {bundles: []}
    bundleManagementList.map((o) => {
      const drawerFound = bundleManagementInitial.find((drawer) => drawer.title === o.title)
      //console.log("Checking " + o.title)
      if(o.title !== drawerFound?.title || o.enableGame !== drawerFound?.enableGame || o.enablePos !== drawerFound?.enablePos || o.unloadable !== drawerFound?.unloadable) {
        //console.log("Different")
        tempChanged = true
        return
      }
    })
    //console.log("All Same: " + !tempChanged)
    setChanged(tempChanged)
  }
  const onRefresh = async () => {
    loading.addLoading()
    const res = await getBundleManagementList()
    //console.log(JSON.stringify(res))
    setBundleManagementList(res)
    const responseCopy = await getBundleManagementList()
    //console.log(JSON.stringify(responseCopy))
    setBundleManagementInitial(responseCopy)
    loading.removeLoading()
  }

  const onChange = (value: boolean, title: string, field: string) => {
     let drawer = bundleManagementList
     const index = drawer.findIndex((o: bundleManager) => o.title === title)
     if( index !== -1 ) {
      drawer[index] = {
        ...drawer[index],
        [field]: value,
      }
      setBundleManagementList([...drawer])
     }
  }

  const onSubmit = async () => {
    loading.addLoading()
    const payload: bundleManagerList = {bundles: []}
    bundleManagementList.map((o) => {
      const drawerFound = bundleManagementInitial.find((drawer) => drawer.title === o.title)
      if(o.title !== drawerFound?.title || o.enableGame !== drawerFound?.enableGame || o.enablePos !== drawerFound?.enablePos || o.unloadable !== drawerFound?.unloadable) payload.bundles.push({
        id: o.id,
        title: o.title,
        enablePos: o.enablePos,
        enableGame: o.enableGame,
        unloadable: o.unloadable,
      })
    })
    await saveBundleManagement(payload)
    await onRefresh()
    loading.removeLoading()

  }

  return (
    <div className="bundle-management">
      <FloatingButton
        text="Save"
        onClick={onSubmit}
        disabled={!changed || !canEdit}
      />
      <CSVLink style={{display: bundleManagementList.length > 0 ? 'flex' : 'none'}}
               filename={"BundleManagement.csv"}
               className="floating-button-left"
               data={bundleManagementList}

               headers={headers}>
        <PlusOutlined style={{color: '#FFF', fontSize: window.innerWidth > 600 ? 20 : 16}} />
        <div className="floating-button__text">
          Export CSV
        </div>
      </CSVLink>

      <List
        columns={[
          {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            width: 150,
            render: (value: string) => value,
          },
          {
            title: 'Enable POS',
            dataIndex: 'enablePos',
            key: 'enablePos',
            width: 150,
            render: (value: string, record: bundleManager) => (
              <SwitchInput
                onChange={(e: boolean) => onChange(e, record.title, 'enablePos')}
                options={{ check: "true", uncheck: "false" }}
                value={value}
                disabled={!canEdit}
              />
            ),
          },
          {
            title: 'Enable Game Terminals',
            dataIndex: 'enableGame',
            key: 'enableGame',
            width: 150,
            render: (value: string, record: bundleManager) => (
              <SwitchInput
                disabled={!canEdit}
                onChange={(e: boolean) => onChange(e, record.title, 'enableGame')}
                options={{ check: "true", uncheck: "false" }}
                value={value}
              />
            ),
          },
          {
            title: 'Unloadable',
            dataIndex: 'unloadable',
            key: 'unloadable',
            width: 150,
            render: (value: string, record: bundleManager) => (
                <SwitchInput
                    disabled={!canEdit}
                    onChange={(e: boolean) => onChange(e, record.title, 'unloadable')}
                    options={{ check: "true", uncheck: "false" }}
                    value={value}
                />
            ),
          },
        ]}
        rows={bundleManagementList}
      />
    </div>
  )
}

export default index
